import { useState } from "react";

export default function useClientApp(): {
  getClientAppSettings: () => {
    AppName: string;
    ClientName: string;
    ClientFullName: string;
    ClientLogo: string;
    CopyrightYear: string;
    ForceReadOnly: boolean;
    DisableSelfRegistration: boolean;
    DatabaseLock: boolean;
    DatabaseLockText: string;
    siteLanguage: string;
    portalDefaultLanguage: string;
    ShowForgotPasswordLink: boolean;
    dateFormat: string;
  };
  setClientApp: (clientApp: {
    AppName: string;
    ClientName: string;
    ClientFullName: string;
    ClientLogo: string;
    CopyrightYear: string;
    ForceReadOnly: boolean;
    DisableSelfRegistration: boolean;
    DatabaseLock: boolean;
    DatabaseLockText: string;
    siteLanguage: string;
    portalDefaultLanguage: string;
    ShowForgotPasswordLink: boolean;
    dateFormat: string;
  }) => void;

  app: {
    AppName: string;
    ClientName: string;
    ClientFullName: string;
    ClientLogo: string;
    CopyrightYear: string;
    ForceReadOnly: boolean;
    DisableSelfRegistration: boolean;
    DatabaseLock: boolean;
    DatabaseLockText: string;
    siteLanguage: string;
    portalDefaultLanguage: string;
    ShowForgotPasswordLink: boolean;
    dateFormat: string;
  };
} {
  const getClientApp = (): {
    AppName: string;
    ClientName: string;
    ClientFullName: string;
    ClientLogo: string;
    CopyrightYear: string;
    ForceReadOnly: boolean;
    DisableSelfRegistration: boolean;
    DatabaseLock: boolean;
    DatabaseLockText: string;
    siteLanguage: string;
    portalDefaultLanguage: string;
    ShowForgotPasswordLink: boolean;
    dateFormat: string;
  } => {
    let clientAppString: string | null = sessionStorage.getItem("ClientApp");
    if (clientAppString == null) clientAppString = "{}";
    return JSON.parse(clientAppString);
  };

  const [app, setApp] = useState(getClientApp());

  const saveClientApp = (clientApp: {
    AppName: string;
    ClientName: string;
    ClientFullName: string;
    ClientLogo: string;
    CopyrightYear: string;
    ForceReadOnly: boolean;
    DisableSelfRegistration: boolean;
    DatabaseLock: boolean;
    DatabaseLockText: string;
    siteLanguage: string;
    portalDefaultLanguage: string;
    ShowForgotPasswordLink: boolean;
    dateFormat: string;
  }) => {
    sessionStorage.setItem("ClientApp", JSON.stringify(clientApp));
    setApp(clientApp);
  };

  return {
    getClientAppSettings: getClientApp,
    setClientApp: saveClientApp,
    app,
  };
}
